import SbkContentSlider from '@/components/content-slider/content-slider'
SbkContentSlider.initialize();